import { I18nMessages } from "../../../../../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages";

export const frIndicators: I18nMessages = {
    'indicators.navbar': 'Indicateurs',
    'indicators.name': 'Indicateur',

    //* INDICATOR FILTERS
    'indicators.filter.creator': 'Créé par',
    'indicators.filter.indicators': 'Indicateurs',
    'indicators.filter.from_date': 'Du',
    'indicators.filter.to_date': 'Au',

    'indicators.filter.label.indicators': 'Indicateurs : {value}',

    //* INDICATOR LIST

    'indicators.title': 'Indicateurs',
    'indicators.list.pageTitle': 'Indicateurs',
    'indicators.list.actions.addIndicator': 'Créer un indicateur',
    'indicators.list.table.emptyLabel': "Il n'y a pas d'indicateur pour le moment",

    //* INDICATOR INFORMATIONS
    'indicators.info.title': 'Titre',
    'indicators.info.title.hint': "Titre de l'indicateur *",

    'indicators.info.ref': 'Référence',
    'indicators.info.ref.hint': "Référence de l'indicateur",

    'indicators.info.description': "Saisissez la description de l'indicateur",

    'indicators.info.icons.title': "Choix de l'icône *",
    'indicators.info.position.title': 'Position de l’indicateur dans le feed des utilisateurs',
    'indicators.info.position.subtitle':
        'Par défaut, cet indicateur sera positionné à la suite des indicateurs déjà créés mais vous pouvez modifier sa position en cliquant sur déplacer.',

    'indicators.info.position.label': 'Position *',
    'indicators.info.position.label.Before': 'Avant',
    'indicators.info.position.label.After': 'Après',
    'indicators.info.indicator.label': 'Indicateur *',

    'indicators.content.tabs.value': 'Valeur',

    //* INDICATOR >> VALUE SECTION
    'indicators.value.def.sectionTitle': "Valeur de l'indicateur",
    'indicators.value.def.secondary.sectionTitle': "Valeur complémentaire de l'indicateur",

    'indicators.value.def.label': 'Libellé',
    'indicators.value.def.label.required': 'Libellé *',
    'indicators.value.def.placeholder': 'Chiffres d’affaires',
    'indicators.value.def.maxFormat': '{count}/{max}',

    'indicators.value.def.unit': 'Unité',
    'indicators.value.def.unit.required': 'Unité *',
    'indicators.value.def.unit.hint': 'Sélectionnez un type de valeur',

    'indicators.value.def.unit.label.Price': 'Montant : €',
    'indicators.value.def.unit.label.Percent': 'Pourcentage : %',
    'indicators.value.def.unit.label.Quantity': 'Quantité',
    'indicators.value.def.unit.label.Point': 'Points : pts',

    'indicators.value.rankingOrder.Ascending.title': 'Classement croissant : ',
    'indicators.value.rankingOrder.Ascending.desc': 'le plus petit est 1er',
    'indicators.value.rankingOrder.Descending.title': 'Classement décroissant : ',
    'indicators.value.rankingOrder.Descending.desc': 'le plus grand est 1er',

    'indicators.value.showRanking.label.disabled':
        'Je ne souhaite pas communiquer le classement au réseau',
    'indicators.value.showRanking.label.enabled': 'Je souhaite communiquer le classement au réseau',

    'indicators.value.secondaryValueEnabled.description':
        'Cette option permet au centre de comparer l’indicateur communiqué à une valeur ( année n-1, périmètre comparable, moyenne nationale, ect.). Une fois cette option activée, il faut saisir le libellé et l’unité de la valeur complémentaire et saisir les valeurs dans le fichier d’import de l’indicateur.',

    //* INDICATOR NOTIFICATIONS // AUTOMATIC
    'indicators.notification.automatic.sectionTitle': 'Notification automatique',
    'indicators.notification.automatic.notifyUpdates':
        'Définir le mode de notification des mises à jour de la valeur',

    'indicators.notification.automatic.mode.Reccurent': 'Périodique',
    'indicators.notification.automatic.mode.Publication':
        "A chaque publication d'une nouvelle valeur",

    'indicators.notification.recurrent.time': 'Heure',

    //* INDICATOR SCORE // MANUAL IMPORT
    'indicators.score.manual.sectionTitle': 'Import manuel',
    'indicators.score.manual.updateRanking':
        'Mettre à jour le classement en important un fichier EXCEL',
    'indicators.score.manual.actions.import': 'Importer',
    'indicators.score.manual.actions.export': 'Exporter le modèle',

    'indicators.score.manual.import.success': 'Import du classement réalisé avec succès !',

    //* INDICATOR SCORE // HISTORIQUE DES IMPORTS
    'indicators.score.import.sectionTitle': 'Historique des imports',
    'indicators.score.import.tab.date': "Date de l'import",
    'indicators.score.import.tab.shops': 'Nombre de centres',
    'indicators.score.import.tab.type': 'Type',
    'indicators.score.import.tab.user': 'Utilisateur',
    'indicators.score.import.tab.delete': 'Supprimer',
    'indicators.score.import.tab.importHistoryEmpty': "Pas d'historique d'import",
    'indicators.score.import.tab.type.Manual': 'Manuel',
    'indicators.score.import.tab.type.Progress': 'Automatique',
    'indicators.score.import.tab.type.Turnover': 'Automatique',
    'indicators.score.import.tab.dateFormat': 'dd/MM/yyyy à HH:mm',
    'indicators.score.import.importNewFile': 'Import un nouveau fichier',

    'indicators.details.import.remove.dialog.title': "Suppression de l'import",
    'indicators.details.import.remove.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cet import ?',

    //* INDICATOR NOTIFICATIONS // MANUAL
    'indicators.notification.manual.sectionTitle': 'Notification manuelle',
    'indicators.notification.manual.notifyShops':
        "Envoyer une notification à tous les collaborateurs des centres concernés par l'indicateur de performance.",

    'indicators.notification.manual.remindAction': 'Notifier',

    //* INDICATOR NOTIFICATIONS // HISTORY
    'indicators.notification.history.sectionTitle': 'Historique des notifications',

    'indicators.notification.history.table.header.date': 'Date de la notification',
    'indicators.notification.history.table.header.content': 'Contenu',
    'indicators.notification.history.table.header.user': 'Utilisateur',
    'indicators.notification.history.table.header.shops': 'Nombre de centres',
    'indicators.notification.history.dateFormat': 'dd/MM/yyyy',

    'indicators.notification.history.notifsHistoryEmpty': "Pas d'historique de notifications",
    'indicators.notification.history.content': 'Indicateur mis à jour',

    //* INDICATOR >> CREATE AND DETAILS
    'indicators.create.pageTitle': 'Création indicateur',
    'indicators.details.pageTitle': 'Détails indicateur',
    'indicators.details.actions.previous': 'Indicateurs',
    'indicators.details.remove.dialog.title': "Suppression de l'indicateur",
    'indicators.details.remove.dialog.content':
        'Êtes-vous sûr de vouloir supprimer cet indicateur ?',

    //* INDICATOR PERMISSIONS
    'backofficeUsers.create.tabs.permissions.sectionTabs.indicators': 'Indicateur',
    'backofficeUsers.permissions.kpi.contentcreate': "Création d'indicateur",

    //* INDICATOR ERRORS
    'toast.apiErrors.ICON_MUST_BE_DEFINED': "L'image doit être définie",

    //* INDICATEUR AUDIENCES DEFINITION
    'indicators.audiences.def.title':
        'Cet indicateur de performance peut être lié à un pont de vente uniquement ou à certains rôles des collaborateurs.',
    'indicators.audiences.def.subtitle': "Sélectionnez votre type d'audience :",

    'indicators.audiences.def.type.shop.title': 'Indicateur centre',
    'indicators.audiences.def.type.shop.subtitle': '(1 valeur par centre)',
    'indicators.audiences.def.type.collaborator.title': 'Indicateur collaborateur',
    'indicators.audiences.def.type.collaborator.subtitle':
        '(1 résultat par collaborateur sélectionné)',

    //* CHALLENGE DETAILS //TABS //RESULTS
    'indicators.details.results.tableHeader.rank': 'Rang',
    'indicators.details.results.tableHeader.user': 'Utilisateur',
    'indicators.details.results.tableHeader.shop': 'Centre',
    'indicators.details.results.tableHeader.shops': 'Centres',
    'indicators.details.results.tableHeader.value': 'Valeur',
    'indicators.details.results.tableHeader.secondaryValue': 'Valeur complémentaire',
    'indicators.details.results.tableHeader.evolution': 'Evolution',

    'indicators.details.results.valuePriceFormat': '{value} €',
    'indicators.details.results.valuePercentFormat': '{value} %',

    'indicators.details.results.evolution.up': '+{value}',
    'indicators.details.results.evolution.unchanged': '-',

    'commons.results.emptyLabel': 'Aucun résultat pour le moment.',

    //* ERRORS
    'toast.apiErrors.INDICATOR_INVALID_RELATIVE_POSITION_INDICATOR':
        "Le positionnement de l'indicateur est invalide",

    'toast.apiErrors.INDICATOR_MISSING_RANKING_ORDER':
        "L'ordre de classement doit être saisi",

};
